import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '47vh',
  },
  spinner: {
    outline: 'none',
  },
});
